import { Box, Skeleton } from '@mui/material'
import React from 'react'

export default function ThreadSkeleton() {
  return (
    <Box
      data-testid="ca-thread-skeleton"
      sx={{ px: 2, py: 2, display: 'flex', flexDirection: 'column', gap: 2.5 }}
    >
      <Skeleton variant="rounded" width="45%" height={40} sx={{ alignSelf: 'flex-end', borderRadius: 2 }} />
      <Box>
        <Skeleton variant="text" width="92%" />
        <Skeleton variant="text" width="78%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="rounded" height={150} sx={{ mt: 1, borderRadius: 1.5 }} />
      </Box>
      <Skeleton variant="rounded" width="35%" height={36} sx={{ alignSelf: 'flex-end', borderRadius: 2 }} />
      <Box>
        <Skeleton variant="text" width="65%" />
        <Skeleton variant="text" width="72%" />
      </Box>
    </Box>
  )
}
